import React from 'react';
import { NewsCard } from './NewsCard';
import { newsData } from '../data/newsData';
interface CategorySectionProps {
  title: string;
  category: string;
}
export const CategorySection = ({
  title,
  category
}: CategorySectionProps) => {
  const categoryNews = newsData.filter(item => item.category === category).slice(0, 3);
  if (categoryNews.length === 0) return null;
  return <section className="mb-12" data-id="element-41">
      <div className="flex items-center justify-between mb-6" data-id="element-42">
        <h2 className="text-2xl font-bold" data-id="element-43">{title}</h2>
        <a href="#" className="text-blue-600 hover:underline text-sm font-medium" data-id="element-44">
          View All
        </a>
      </div>
      <div className="grid grid-cols-1 gap-6" data-id="element-45">
        {categoryNews.length > 0 && <NewsCard title={categoryNews[0].title} excerpt={categoryNews[0].excerpt} imageUrl={categoryNews[0].imageUrl} author={categoryNews[0].author} date={categoryNews[0].date} category={categoryNews[0].category} isLarge={true} id={newsData.findIndex(item => item.title === categoryNews[0].title)} data-id="element-46" />}
        {categoryNews.length > 1 && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-47">
            {categoryNews.slice(1).map((news, index) => <NewsCard key={index} title={news.title} excerpt={news.excerpt} imageUrl={news.imageUrl} author={news.author} date={news.date} category={news.category} id={newsData.findIndex(item => item.title === news.title)} data-id="element-48" />)}
          </div>}
      </div>
    </section>;
};